module.exports = __webpack_public_path__ + "static/media/glass.330713f6.svg";